import { Card, Button } from '../primitives';
import { ADD_ONS } from '../../Pricing';
import { useTranslation } from '../../hooks/useTranslation';

export default function SubscriptionInfo({ subscription, onClose, totalCost }) {
    const t = useTranslation();
    return (
        <Card className='white'>
            <h4>{t('Subscription Information')}</h4>
            <div style={{marginBottom: '20px'}}>
                <h5>{t('Cost Breakdown')}</h5>
                <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '8px'}}>
                    <span>{t('Base Subscription')}:</span>
                    <span>{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(subscription.cost / 100)}</span>
                </div>
                {subscription.addons.map(addon => {
                    const addonInfo = ADD_ONS.find(a => a.id === addon.id);
                    return addon.enabled && addon.cost > 0 && (
                        <div key={addon.id} style={{display: 'flex', justifyContent: 'space-between', marginBottom: '8px'}}>
                            <span>{addonInfo?.name || `Add-on (${addon.id})`}:</span>
                            <span>{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(addon.cost / 100)}</span>
                        </div>
                    )
                })}
                <div style={{borderTop: '1px solid #eee', paddingTop: '8px', display: 'flex', justifyContent: 'space-between', fontWeight: 'bold'}}>
                    <span>{t('Total:')}</span>
                    <span>{totalCost}</span>
                </div>
            </div>
            <Button onClick={onClose}>{t('Close')}</Button>
        </Card>
    )
}
